import { render, staticRenderFns } from "./WikiSearchBar.vue?vue&type=template&id=26d4ee1d"
import script from "./WikiSearchBar.vue?vue&type=script&lang=ts"
export * from "./WikiSearchBar.vue?vue&type=script&lang=ts"
import style0 from "./WikiSearchBar.vue?vue&type=style&index=0&id=26d4ee1d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports